import React, { useEffect, useState } from "react";
import { Sun, Moon, Monitor, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { getAdminPreference, setAdminPreference } from "@/lib/theme";

const OPTIONS = [
  { key: "light", label: "Light", Icon: Sun },
  { key: "dark", label: "Dark", Icon: Moon },
  { key: "system", label: "System", Icon: Monitor },
];

export const ThemeToggle = () => {
  const [pref, setPref] = useState(getAdminPreference());

  useEffect(() => {
    const sync = () => setPref(getAdminPreference());
    window.addEventListener("rd-theme-change", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("rd-theme-change", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const choose = (key) => {
    setAdminPreference(key);
    setPref(key);
  };

  const Current = (OPTIONS.find((o) => o.key === pref) || OPTIONS[1]).Icon;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Change theme"
          data-testid="theme-toggle-button"
          className="inline-flex items-center justify-center h-9 w-9 rounded-md border border-white/10 text-white/70 hover:text-white hover:bg-white/5 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        >
          <Current size={17} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-[#0E1424] border-white/10 text-white w-40"
        data-testid="theme-toggle-menu"
      >
        {OPTIONS.map(({ key, label, Icon }) => (
          <DropdownMenuItem
            key={key}
            onClick={() => choose(key)}
            data-testid={`theme-option-${key}`}
            className="cursor-pointer text-white/80 focus:bg-white/5 focus:text-white flex items-center gap-2"
          >
            <Icon size={15} className="text-white/60" />
            <span className="flex-1">{label}</span>
            {pref === key && <Check size={15} className="text-[#66B2FF]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
